import { render } from "./BlockTextImage.vue?vue&type=template&id=33e7305a"
import script from "./BlockTextImage.vue?vue&type=script&lang=js"
export * from "./BlockTextImage.vue?vue&type=script&lang=js"

import "./BlockTextImage.vue?vue&type=style&index=0&id=33e7305a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__